import { Component, OnInit } from '@angular/core';
import { EtapaRastreioService } from '../services/etapa-rastreio.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { EtapaRastreio } from '../models/etapa-rastreio';
import { CarregandoService } from '../services/carregando.service';
import { UtilitarioService } from '../services/utilitario.service';
import { NotificacaoService } from '../services/notificacao.service';
import { MatDialog, PageEvent } from '@angular/material';
import { PaginatorService } from '../services/paginator.service';
import swal from 'sweetalert2';
import { CadastrarEtapaRastreioModalComponent } from '../modals/cadastrar-etapa-rastreio-modal/cadastrar-etapa-rastreio-modal.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

declare const $: any;

@Component({
  selector: 'app-etapa-rastreio',
  templateUrl: './etapa-rastreio.component.html',
  styleUrls: ['./etapa-rastreio.component.scss']
})
export class EtapaRastreioComponent implements OnInit {
  nome: string;
  etapasRastreio: EtapaRastreio[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  situacao = [{ id: -1, descricao: 'Todos' }, { id: 1, descricao: 'Ativo' }, { id: 0, descricao: 'Inativo' }];
  situacaoSelecionada: number = 1;
  enumInterna = [{ id: 1, descricao: 'Aguardando Pagamento' }, { id: 2, descricao: 'Aguardando Faturamento' }, { id: 3, descricao: 'Aguardando Separação' }, { id: 4, descricao: 'Aguardando Transportadora' }, { id: 5, descricao: 'Pedido Coletado' }, { id: 6, descricao: 'Pedido Entregue' }, { id: 0, descricao: 'Outros' }];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private etapaRastreioService: EtapaRastreioService,
    private carregandoService: CarregandoService,
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = 30;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarEtapas();
  }

  filtra() {
    this.buscarEtapas();
  }

  buscarEtapas() {
    this.carregandoService.mostra('buscarEtapas');

    this.etapaRastreioService.consultarComPaginacao(this.nome, this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc'), this.situacaoSelecionada).subscribe((data: any) => {
      this.etapasRastreio = data.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarEtapas');
    }, (erro) => {
      this.carregandoService.esconde('buscarEtapas');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarEtapas();
  }

  excluirItem(idEtapa) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a etapa?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirItem');
        this.etapaRastreioService.excluir(idEtapa).subscribe(resp => {
          this.notificacaoService.sucesso('Etapa excluída com sucesso!!!');
          this.carregandoService.esconde('excluirItem');
          this.buscarEtapas();

        }, (erro) => {
          this.carregandoService.esconde('excluirItem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  enumEtapa(id) {
    const etapa = this.enumInterna.find(x => x.id === id);
    return etapa ? etapa.descricao : ' - ';
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarEtapaRastreioModalComponent, {
      width: largura > 930 ? '900px' : (($('body').width()).toString() + 'px'),
      data: {
        ordem: this.etapasRastreio.length + 1,
        etapasExistentes: this.etapasRastreio.map(x => x.enumInterno).filter(x => x !== 0)
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: EtapaRastreio) => {
      if (result) {
        this.buscarEtapas();
      }
    });
  }

  editarItem(idEtapa: number) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarEtapaRastreioModalComponent, {
      width: largura > 930 ? '900px' : (($('body').width()).toString() + 'px'),
      data: {
        idEtapa: idEtapa,
        etapasExistentes: this.etapasRastreio.map(x => x.enumInterno).filter(x => x !== 0)
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: EtapaRastreio) => {
      if (result) {
        this.situacaoSelecionada = result.ativo;
        this.buscarEtapas();
        this.reordenaEtapas();
      }
    });
  }

  reordenaEtapas() {
    // Atualiza a lista de etapas ativas, ordenando por ordem
    const etapasAtivas = this.etapasRastreio
      .filter(e => e.ativo !== 0)
      .sort((a, b) => a.ordem - b.ordem);

    // Reatribui a ordem sequencialmente para as etapas ativas
    etapasAtivas.forEach((etapa, idx) => {
      if (etapa.ordem !== idx + 1) {
        etapa.ordem = idx + 1;
        this.salvar(etapa);
      }
    });
  }

  salvar(etapa: EtapaRastreio) {
    this.carregandoService.mostra('salvar');
    this.etapaRastreioService.salvar(etapa).subscribe((retorno) => {
      // this.notificacaoService.sucesso('Setor salvo com sucesso!!!');
      this.carregandoService.esconde('salvar');
    }, (erro) => {
      this.carregandoService.esconde('salvar');
      this.notificacaoService.erro(erro);
    });
  }

  drop(event: CdkDragDrop<EtapaRastreio[]>) {
    moveItemInArray(this.etapasRastreio, event.previousIndex, event.currentIndex);

    this.etapasRastreio.forEach((etapa, index) => {
      etapa.ordem = index + 1;

      this.salvar(etapa);
    });
  }

  ngOnDestroy(): void { }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }
}
